module.exports = __webpack_public_path__ + "img/div6-1s.870826e1.jpg";